import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Loader from '../../../globalComponents/loader/DPLoader';
import { useEditBatchConfiguration } from '../hooks/useEditBatchConfiguration';
import BatchConfigurationForm from './BatchConfigurationForm';
import { PreFormBatchConfiguration } from '../types/BatchConfigType';

interface EditBatchConfigurationFormProps {
  batchConfigurationId: string;
  preFormBatchConfiguration?: PreFormBatchConfiguration;
  assetId: string;
}

export default function EditBatchConfigurationForm({
  batchConfigurationId,
  preFormBatchConfiguration,
  assetId,
}: EditBatchConfigurationFormProps) {
  const { t } = useTranslation();
  const { batchConfigurationDetails, isLoadingFormDetails, batchConfigurationDetailsError } =
    useEditBatchConfiguration(batchConfigurationId);

  if (isLoadingFormDetails) return <Loader />;

  if (batchConfigurationDetailsError)
    return (
      <Alert severity="error">
        {t('batchConfig.loadError', 'Error loading batch configuration details:')} {batchConfigurationDetailsError.message}
      </Alert>
    );

  if (!batchConfigurationDetails)
    return <Alert severity="warning">{t('batchConfig.noDetails', 'No batch configuration details found.')}</Alert>;
  return (
    <BatchConfigurationForm
      key={JSON.stringify(batchConfigurationDetails)}
      initialFormData={batchConfigurationDetails}
      preFormBatchConfiguration={preFormBatchConfiguration}
      assetId={assetId}
    />
  );
}
